import { Form } from "antd";
import UserSelect from "./UserSelect";
import React, { useEffect, useContext } from 'react';
import { FormUserSelectSettings } from './FormUserSelectSettings';

import { Resizer,FormContext } from 'wsc-react-custom-form';

const defaultProps = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    fillSpace: 'no',
    padding: ['0', '0', '0', '0'],
    margin: ['0', '0', '0', '0'],
    background: { r: 255, g: 255, b: 255, a: 1 },
    color: { r: 0, g: 0, b: 0, a: 1 },
    shadow: 0,
    radius: 0,
    width: '100%',
    height: 'auto',
};

export const FormUserSelect = (props) => {
    props = {
        ...defaultProps,
        ...props,
    };
    const {
        flexDirection,
        alignItems,
        justifyContent,
        fillSpace,
        background,
        color,
        padding,
        margin,
        shadow,
        radius,
        label,
        labelSpan,
        labelOffset,
        wrapperSpan,
        wrapperOffset,
        showLabel,
        name,
        rules,
        multiple,
        disabled,
        roleName,
        initial,
    } = props;

    const { form, formdata } = useContext(FormContext);

    useEffect(() => {
        //表单值发生变化，反应到组件中
        // let fileds = [];
        // fileds[name] = formdata[name];
        // form.setFieldsValue(fileds);
        form.setFieldValue(name, formdata[name]);
    }, [formdata[name]]);

    let noLabel = (showLabel == "false");
    return (<Resizer
        propKey={{ width: 'width', height: 'height' }}
        style={{
            justifyContent,
            flexDirection,
            alignItems,
            background: `rgba(${background.r},${background.g},${background.b},${background.a})`,
            color: `rgba(${color.r},${color.g},${color.b},${color.a})`,
            padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
            margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
            boxShadow:
                shadow === 0
                    ? 'none'
                    : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
            borderRadius: `${radius}px`,
            flex: fillSpace === 'yes' ? 1 : 'unset',
        }}
    ><Form.Item
        style={{ width: "100%" }}
        label={noLabel?null:label}
        labelCol={{span: labelSpan, offset: labelOffset}}
        wrapperCol={{span: wrapperSpan, offset: wrapperOffset}}
        name={name}
        initialValue={formdata[name]}
        rules={rules}
    >
        <UserSelect multiple={multiple} disabled={disabled} roleName={roleName} initial={initial}/>
    </Form.Item></Resizer>);
};


FormUserSelect.craft = {
    displayName: 'FormUserSelect',
    props: {
        name: "User",
        label: "选择用户",
        labelSpan: 6,
        labelOffset: 0,
        wrapperSpan: 18,
        wrapperOffset: 0,
        showLabel: "true",
        multiple: "false",
        disabled: "false",
        roleName: '',
        initial: 'false',
        rules: [{ required: true, message: "用户必须选择！" }],
        ...defaultProps
    },
    related: {
        toolbar: FormUserSelectSettings,
    },
};

FormUserSelect.Icon = () => {
    return (<span>FormUserSelect</span>);
}